// @flow

import {
  LOCATION_CHANGE,
  SET_REPORTS,
  SET_REPORTS_ERRORS,
  START_SPINNER,
  STOP_SPINNER,
  IS_LOADING,
  TREE,
  REPORTS,
  REPORTS_ERRORS,
} from './../constants'

import initialState from './initialState'


export default {
  [LOCATION_CHANGE]: function<S> (state: S): S {
    return {
      ...state,
      ...initialState,
    }
  },
  [START_SPINNER]: function<S> (state: S): S {
    return {
      ...state,
      ...state[TREE],
      [IS_LOADING]: true,
    }
  },
  [STOP_SPINNER]: function<S> (state: S): S {
    return {
      ...state,
      ...state[TREE],
      [IS_LOADING]: false,
    }
  },
  [SET_REPORTS]: function<S> (state: S, payload: string): S {
    return {
      ...state,
      ...state[TREE],
      [REPORTS]: [...payload],
    }
  },
  [SET_REPORTS_ERRORS]: function<S> (state: S, payload: string): S {
    return {
      ...state,
      ...state[TREE],
      [REPORTS_ERRORS]: payload,
    }
  },
}
